import strings from 'strings';
import i18n from '../i18n';
import { height, width } from '../constants/popupSizes';

export const UNBREAKABLE_THIN_SPACE_CHAR = ' ';

export const toThousandSeparatedNumber = (number, separator = UNBREAKABLE_THIN_SPACE_CHAR) => (
  !number && number !== 0
    ? null
    : number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator).replace(/\./g, ',')
);

export const toAtis = number =>
  `${toThousandSeparatedNumber(number || 0)}${UNBREAKABLE_THIN_SPACE_CHAR}${strings.atis}`;

export const replaceWhitespaceWithNonBreakableSpace = text =>
  text.replace(/ /g, '\u00a0');

export const replaceDots = number => number.toString().replace(/\./g, ',');

export const toThousandSeparatedSumma = summa => toThousandSeparatedNumber(summa) + UNBREAKABLE_THIN_SPACE_CHAR;

export const getFormattedText = (stringName, count) => (
  i18n.t(stringName, count)
);

export const parseSum = (sumStr) => {
  const trimed = sumStr.split(' ').join('');
  if (!trimed) {
    return 0;
  }
  const parsed = Number.parseFloat(trimed);
  return Number.isNaN(parsed) ? 0 : parsed;
};

export const reload = () => window.location.reload();

export const openNewTab = url => window.open(url, '_blank');

export const openInSameTab = url => window.open(url, '_self');

export const openTab = (url, newTab = true) => (newTab ? openNewTab(url) : openInSameTab(url));

const openInPopupWindow = (url, title) => {
  const y = ((window.top.outerHeight - height) / 2) + window.top.screenY;
  const x = ((window.top.outerWidth - width) / 2) + window.top.screenX;
  return window.open(url, title, `width=${width}, height=${height}, top=${y}, left=${x}`);
};

export const openPassportPopup = (e, url) => {
  e.stopPropagation();
  openInPopupWindow(url, 'passport', width, height);
  e.preventDefault();
};

export const hasValue = value => !!value || value === 0;
